import { Retailer_Network_User_Role } from '@occc/graphql';

import { useRetailerNetworkUserSelector } from '../../retailer-network-context/use-retailer-network-user.selector';

export const useGetIsUserPermittedToAssociateAndDisassociate = (
  targetUserRole: Retailer_Network_User_Role,
) => {
  const { isRetailerNetworkSiteAdmin } = useRetailerNetworkUserSelector();

  const isTargetUserRetailerNetworkSiteAdmin =
    targetUserRole === Retailer_Network_User_Role.SiteAdmin;

  if (isRetailerNetworkSiteAdmin && isTargetUserRetailerNetworkSiteAdmin) {
    return false;
  }

  return true;
};
